import { render, staticRenderFns } from "./PowerbiReport.vue?vue&type=template&id=84821404&"
import script from "./PowerbiReport.vue?vue&type=script&lang=js&"
export * from "./PowerbiReport.vue?vue&type=script&lang=js&"
import style0 from "./PowerbiReport.vue?vue&type=style&index=0&id=84821404&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports